import { createContext, useContext, useEffect, useState } from "react";

const STORAGE_KEY = "crednx-theme";
const ThemeCtx = createContext({ theme: "light", setTheme: () => {}, toggle: () => {} });

function getInitial() {
    if (typeof window === "undefined") return "light";
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored === "light" || stored === "dark") return stored;
    return window.matchMedia?.("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

export function ThemeProvider({ children }) {
    const [theme, setThemeState] = useState(getInitial);

    useEffect(() => {
        const root = document.documentElement;
        root.classList.remove("light", "dark");
        root.classList.add(theme);

        // Add a transient class for smooth property transitions, then remove so scroll/focus animations aren't affected
        root.classList.add("theme-transition");
        const t = window.setTimeout(() => root.classList.remove("theme-transition"), 400);

        try {
            window.localStorage.setItem(STORAGE_KEY, theme);
        } catch {
            /* localStorage may be unavailable */
        }
        return () => window.clearTimeout(t);
    }, [theme]);

    const setTheme = (t) => setThemeState(t === "dark" ? "dark" : "light");
    const toggle = () => setThemeState((t) => (t === "dark" ? "light" : "dark"));

    return (
        <ThemeCtx.Provider value={{ theme, setTheme, toggle }}>
            {children}
        </ThemeCtx.Provider>
    );
}

export function useTheme() {
    return useContext(ThemeCtx);
}
